// Most images on a task sheet issue, and on each manager's solution
export const MAX_TASK_SHEET_IMAGES = 5;

// A manager's solution images: `images` (up to 5) on newer solutions, a
// single `image` on older ones
export const solutionImages = (solution) => {
  if (Array.isArray(solution?.images) && solution.images.length > 0) {
    return solution.images.filter(Boolean);
  }
  return solution?.image ? [solution.image] : [];
};
